// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MedicineBoxFilledSvg from "@ant-design/icons-svg/es/asn/MedicineBoxFilled";
import AntdIcon from '../components/AntdIcon';

var MedicineBoxFilled = function MedicineBoxFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: MedicineBoxFilledSvg
  }));
};

MedicineBoxFilled.displayName = 'MedicineBoxFilled';
export default React.forwardRef(MedicineBoxFilled);